import gql from "graphql-tag";
import { PAGE_INFO_FRAGMENT } from "./fragments";

export const GET_EXISTING_REGISTRATIONS = gql`
  query getExistingEventIdRegistrations($cursor: String) {
    registerables(
      filters: [
        { field: isActive, operation: eq, value: "true" }
        { field: allBrands, operation: eq, value: "true" }
      ]
      after: $cursor
    ) {
      pageInfo {
        hasNextPage
        endCursor
        totalRecords
      }
      edges {
        node {
          id
          __typename
          ... on Registration {
            course {
              id # this is actually the Event ID
              title
            }
          }
        }
      }
    }
  }
`;

const PRIVATE_TRAINING_FRAGMENT = gql`
  fragment privateTrainingDetails on EventConnection {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        name
        deliveryMethod
        start
        end
        timeZoneName
        remainingPlaces
        course {
          id
          code
        }
        location {
          id
          name
        }
        locale {
          id
          language
        }
        registrationOpen
        registrationOpensAt
        imageUrl
        instructors {
          id
          name
        }
      }
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;

export const PRIVATE_TRAINING_COORDINATOR_COUNT = gql`
  query getPrivateTrainingForCoordinatorCount($filters: [EventFieldFilter!]) {
    privateTrainingForCoordinator(filters: $filters) {
      pageInfo {
        totalRecords
      }
    }
  }
`;

export const PRIVATE_TRAINING_COORDINATOR_QUERY = gql`
  query getPrivateTrainingForCoordinator(
    $filters: [EventFieldFilter!]
    $first: Int
    $offset: Int
  ) {
    privateTrainingForCoordinator(
      first: $first
      offset: $offset
      filters: $filters
    ) {
      ...privateTrainingDetails
    }
  }
  ${PRIVATE_TRAINING_FRAGMENT}
`;

export const PRIVATE_TRAINING_SELF_COUNT = gql`
  query getPrivateTrainingCount($filters: [EventFieldFilter!]) {
    privateTraining(filters: $filters) {
      pageInfo {
        totalRecords
      }
    }
  }
`;

export const PRIVATE_TRAINING_SELF_QUERY = gql`
  query getPrivateTraining(
    $filters: [EventFieldFilter!]
    $first: Int
    $offset: Int
  ) {
    privateTraining(first: $first, offset: $offset, filters: $filters) {
      ...privateTrainingDetails
    }
  }
  ${PRIVATE_TRAINING_FRAGMENT}
`;
